import { useEffect, useRef } from "react"
import { AppView } from "../Main/Main";
import { linkTo } from "../Results/utils";

enum MessageType {
  Navigation = 'NAVIGATION',
  Results = 'RESULTS'
}

export function NewForm({setView}: {setView: (view: AppView) => void}) {
  const frameRef = useRef<HTMLIFrameElement>(null);
  useEffect(() => {
    const handleMessage = (e: MessageEvent) => {
      if (e.data.type && e.data.type === MessageType.Navigation)
        linkTo(e.data.href);
      if (e.data.type && e.data.type === MessageType.Results)
        setView(AppView.Results);
    }

    window.addEventListener('message', handleMessage);

    return () => window.removeEventListener('message', handleMessage);
  })

  return (
    <iframe
      title="formframe"
      ref={frameRef}
      src="https://crayola-creative-profile.squarespace.com/profile"
      className="h-full w-full border-0"
    >

    </iframe>
  )
}